"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = route;

var _parseRoute = _interopRequireDefault(require("./parseRoute"));

var _resolveStateFromPath = _interopRequireDefault(require("./resolveStateFromPath"));

var _resolvePathFromState = _interopRequireDefault(require("./resolvePathFromState"));

var _paramsEncoding = require("./utils/paramsEncoding");

var _jsonParamsEncoding = require("./utils/jsonParamsEncoding");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function normalizeChildren(children) {
  if (Array.isArray(children) || typeof children === 'function') {
    return children;
  }

  return children ? [children] : [];
}

function isRoute(val) {
  return val && '_isRoute' in val;
}

function normalizeArgs(path, childrenOrOpts, children) {
  if (typeof path === 'object') {
    return path;
  }

  if (Array.isArray(childrenOrOpts) || typeof childrenOrOpts === 'function' || isRoute(childrenOrOpts)) {
    return {
      path,
      children: normalizeChildren(childrenOrOpts)
    };
  }

  if (children) {
    return _objectSpread(_objectSpread({
      path
    }, childrenOrOpts), {}, {
      children: normalizeChildren(children)
    });
  }

  return _objectSpread({
    path
  }, childrenOrOpts);
}

function route(routeOrOpts, childrenOrOpts, children) {
  return createNode(normalizeArgs(routeOrOpts, childrenOrOpts, children));
}

route.scope = function scope(scopeName) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  var options = normalizeArgs(...rest);
  return createNode(_objectSpread(_objectSpread({}, options), {}, {
    scope: scopeName
  }));
};

function normalize() {
  for (var _len2 = arguments.length, paths = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    paths[_key2] = arguments[_key2];
  }

  return paths.reduce((acc, path) => acc.concat(path.split('/')), []).filter(Boolean);
}

route.intents = function intents(base) {
  var basePath = normalize(base).join('/');
  return route("".concat(basePath, "/:intent"), [route(':params', {
    transform: {
      params: {
        toState: _paramsEncoding.decodeParams,
        toPath: _paramsEncoding.encodeParams
      }
    }
  }, [route(':payload', {
    transform: {
      payload: {
        toState: _jsonParamsEncoding.decodeJsonParams,
        toPath: _jsonParamsEncoding.encodeJsonParams
      }
    }
  })])]);
};

var EMPTY_STATE = {};

function isRoot(pathname) {
  var parts = pathname.split('/');

  for (var i = 0; i < parts.length; i++) {
    if (parts[i]) {
      return false;
    }
  }

  return true;
}

function createNode(options) {
  var path = options.path,
      scope = options.scope,
      transform = options.transform,
      children = options.children;

  if (!path) {
    throw new TypeError('Missing path');
  }

  var parsedRoute = (0, _parseRoute.default)(path);
  return {
    _isRoute: true,
    // todo: make a Router class instead
    scope,
    route: parsedRoute,
    children: children || [],
    transform,

    encode(state) {
      return (0, _resolvePathFromState.default)(this, state);
    },

    decode(_path) {
      return (0, _resolveStateFromPath.default)(this, _path);
    },

    isRoot: isRoot,

    isNotFound(pathname) {
      return this.decode(pathname) === null;
    },

    getBasePath() {
      return this.encode(EMPTY_STATE);
    },

    getRedirectBase(pathname) {
      if (isRoot(pathname)) {
        var basePath = this.getBasePath(); // Check if basepath is something different than given

        if (pathname !== basePath) {
          return basePath;
        }
      }

      return null;
    }

  };
}